import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './AddForm.styles';

const AddForm = props => {
  const { styles: customStyles, ...rest } = props;
  return <form className={css(styles.form, customStyles)} {...rest} />;
};

export default AddForm;



// WEBPACK FOOTER //
// ./src/components/forms/addform/AddForm.js